import React from 'react';
import { useTerminologia } from '../../hooks/useTerminologia';

const formatARS = (value) =>
    value != null
        ? new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 }).format(value)
        : '';

const PdfDeudores = ({ deudores = [] }) => {
    const t = useTerminologia();
    const total = deudores.reduce((sum, d) => sum + (d.Deuda || 0), 0);

    return (
        <>
            <div className="pdf-section-title">DEUDORES DE EXPENSAS</div>
            <table className="pdf-data-table">
                <thead>
                    <tr>
                        <th>{t.UF}</th>
                        <th>Propietario</th>
                        <th className="pdf-col-number">Deuda</th>
                    </tr>
                </thead>
                <tbody>
                    {deudores.length === 0 ? (
                        <tr>
                            <td colSpan={3} style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                Sin deudores registrados
                            </td>
                        </tr>
                    ) : (
                        deudores.map((d, i) => (
                            <tr key={i}>
                                <td>{d.UF}</td>
                                <td>{d.Propietario}</td>
                                <td className="pdf-col-number">{formatARS(d.Deuda)}</td>
                            </tr>
                        ))
                    )}
                    {deudores.length > 0 && (
                        <tr className="pdf-row-total">
                            <td colSpan={2}>Total deuda</td>
                            <td className="pdf-col-number">{formatARS(total)}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
};

export default PdfDeudores;
